export const searchWarehouseByPostcode = (warehouses, postcode) => {
  const searchedWarehouses = []
  warehouses?.map((warehouse) => {
    if (warehouse.zipcode?.slice(0, postcode.length) === postcode) {
      searchedWarehouses.push(warehouse)
    }
  })
  return searchedWarehouses
}
